export default __webpack_public_path__ + "static/media/rundzelle.ef5f1a94.png";